import { Action, createReducer, on } from '@ngrx/store';
import { CountryUS, IRATrustTypes } from '@shared/models';
import * as dayjs from 'dayjs';

import { StartOverStateCleared } from '../../actions/start-over/start-over.actions';
import * as trustActions from '../../actions/trust/trust.actions';

export interface TrustState {
  trustName: string;
  trustDate?: string;
  numberQuestion?: string;
  countryQuestion: CountryUS;
  taxResidencyQuestion: CountryUS;
  grantorQuestion?: CountryUS;
  trustAddress: boolean;
  address?: string;
  zipCode?: string;
  city?: string;
  state?: string;
  mailingAddress: boolean;
  mailAddress?: string;
  mailZipCode?: string;
  mailCity?: string;
  mailState?: string;
  typeOfTrust?: IRATrustTypes;
}

export const initialState: TrustState = {
  trustName: '',
  trustDate: '',
  numberQuestion: '',
  countryQuestion: CountryUS.EMPTY,
  taxResidencyQuestion: CountryUS.EMPTY,
  grantorQuestion: CountryUS.EMPTY,
  trustAddress: false,
  address: '',
  zipCode: '',
  city: '',
  state: '',
  mailingAddress: false,
  mailAddress: '',
  mailZipCode: '',
  mailCity: '',
  mailState: '',
};

const trustReducer = createReducer(
  initialState,
  on(trustActions.TrustUpdate, (_state, { payload }) => ({
    ...payload,
    ...(payload.trustDate && { trustDate: dayjs(payload.trustDate).format('MM/DD/YYYY') }),
  })),
  on(trustActions.TypeOfTrustUpdate, (state, { payload }) => ({
    ...state,
    typeOfTrust: payload,
  })),
  on(StartOverStateCleared, () => ({ ...initialState })),
);

export function reducer(state: TrustState, action: Action) {
  return trustReducer(state, action);
}
